import React from 'react';
import { Lock, Warning, Home } from '@mui/icons-material';

interface AccessDeniedProps {
  message?: string;
  onRetry?: () => void;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ 
  message = "You do not have access to this corporation's data.",
  onRetry 
}) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '48px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '500px',
        margin: '20px'
      }}>
        {/* Lock Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: '#fff3e0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <Lock style={{ fontSize: '40px', color: '#ff9800' }} />
        </div>

        {/* Title */}
        <h1 style={{ 
          color: '#333',
          marginBottom: '16px',
          fontSize: '24px',
          fontWeight: 600
        }}>
          Access Denied
        </h1>

        {/* Message */}
        <p style={{ 
          color: '#666',
          marginBottom: '24px',
          fontSize: '16px',
          lineHeight: '1.6'
        }}>
          {message}
        </p>

        {/* Action Buttons */}

        {/* Warning notice */}
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px',
          backgroundColor: '#fff8e1',
          padding: '16px',
          borderRadius: '8px',
          marginBottom: '24px',
          textAlign: 'left'
        }}>
          <Warning style={{ color: '#f57c00', fontSize: '20px', marginTop: '2px' }} />
          <div style={{ fontSize: '14px', color: '#5d4037' }}>
            <strong>What happened?</strong>
            <p style={{ margin: '8px 0 0 0' }}>
              Your account does not have permission to view data for this corporation. 
              This could be because:
            </p>
            <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
              <li>You're not assigned to this corporation</li>
              <li>Your access permissions have changed</li>
              <li>The corporation ID in the URL is incorrect</li>
            </ul>
          </div>
        </div>

        {/* Action buttons */}
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          {onRetry && (
            <button
              onClick={onRetry}
              style={{
                padding: '12px 24px',
                backgroundColor: '#2196F3',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1976D2'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2196F3'}
            >
              Try Again
            </button>
          )}
          
          <button
            onClick={() => {
              // Try to communicate with parent window
              if (window.parent !== window) {
                window.parent.postMessage({ type: 'ACCESS_DENIED' }, '*');
              }
            }}
            style={{
              padding: '12px 24px',
              backgroundColor: 'transparent',
              color: '#666',
              border: '1px solid #ddd',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#f5f5f5';
              e.currentTarget.style.borderColor = '#ccc';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = '#ddd';
            }}
          >
            <Home style={{ fontSize: '18px' }} />
            Contact Support
          </button>
        </div>

        {/* Footer */}
        <p style={{
          marginTop: '24px',
          fontSize: '12px',
          color: '#999'
        }}>
          If you believe this is an error, please contact your administrator.
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;
